import GlideCarousel from '@glidejs/glide';

const buildDots = (glide, totalSlides) => {
    if (!isNaN(totalSlides) && totalSlides > 0) {
        const bulletsContainer = glide.querySelector('.glide__bullets');
        const fragment = document.createDocumentFragment();

        for (let i = 0; i < totalSlides; i++) {
            const bullet = document.createElement('button');
            bullet.className = 'glide__bullet';
            bullet.setAttribute('data-glide-dir', `=${i}`);
            fragment.appendChild(bullet);
        }

        bulletsContainer.appendChild(fragment);
    }
}

if (document.querySelector('.testimonial-carousel')) {
    const glideTestimonial = new GlideCarousel('.testimonial-carousel', {
        type: 'carousel',
        gap: 28,
        startAt: 0,
        perView: 1,
        autoplay: 3000,
        hoverpause: true,
        animationDuration: 600,
    }).mount();
}

const clientsCarousel = document.querySelector('.clients-carousel');
if (clientsCarousel) {
    let glideClients = null;

    const initializeClientsCarousel = () => {
        const glideSlidesEl = clientsCarousel.querySelector('.glide__slides');
        const glideArrowsEl = clientsCarousel.querySelector('.glide__arrows');
        const glideBulletsEl = clientsCarousel.querySelector('.glide__bullets');
        const glideSlideEls = clientsCarousel.querySelectorAll('.glide__slide');
        const totalSlides = parseInt(clientsCarousel.getAttribute('data-glide-total'), 10);

        if (window.innerWidth >= 1024 && totalSlides > 5 || (window.innerWidth < 1024 && totalSlides >= 3)) {
            if (!glideClients) {
                glideSlidesEl.classList.remove('justify-center');
                glideArrowsEl.classList.add('flex');
                glideArrowsEl.classList.remove('hidden');
                glideBulletsEl.classList.add('flex');
                glideBulletsEl.classList.remove('hidden');
                glideSlideEls.forEach(el => el.classList.remove('w-1/2', 'md:w-1/3', 'lg:w-1/5'))

                buildDots(clientsCarousel, totalSlides);

                glideClients = new GlideCarousel('.clients-carousel', {
                    type: 'carousel',
                    perView: Math.max(totalSlides, 5),
                    gap: 0,
                    autoplay: 3000,
                    hoverpause: true,
                    animationDuration: 600,
                    breakpoints: {
                        1024: {
                            perView: Math.max(totalSlides, 3),
                        },
                        768: {
                            perView: 2,
                        },
                    }
                }).mount();
            }
        } else {
            glideSlidesEl.classList.add('justify-center');
            glideArrowsEl.classList.add('hidden');
            glideArrowsEl.classList.remove('flex');
            glideBulletsEl.classList.add('hidden');
            glideBulletsEl.classList.remove('flex');
            glideSlideEls.forEach(el => el.classList.add('w-1/2', 'md:w-1/3', 'lg:w-1/5'));

            if (glideClients) {
                glideClients.destroy();
                glideClients = null;
                clientsCarousel.querySelector('.glide__bullets').innerHTML = '';
            }
        }
    }

    initializeClientsCarousel();

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initializeClientsCarousel, 200);
    });
}

if (document.querySelector('.featured-carousel')) {
    const glideFeatured = new GlideCarousel('.featured-carousel', {
        type: 'carousel',
        perView: 4,
        gap: 0,
        autoplay: 3000,
        hoverpause: true,
        animationDuration: 600,
        breakpoints: {
            1024: {
                perView: 3,
            },
            768: {
                perView: 2,
            },
            480: {
                perView: 1,
            }
        }
    }).mount();
}
